export default __webpack_public_path__ + "6c6a72607541ffd7c0eaf8f0c6f41fe0.svg";